export default "__VITE_ASSET__CYevqmMa__"